<template>
	<section id="about" class="sg-section" style="background: #fff; position: relative;">
		<v-container>
			<v-row align="center">
				<v-col cols="12" md="6" order="2" order-md="1">
					<h2 class="sg-section-title text-md-right">{{ content.title }}</h2>
					<div class="sg-gold-line" style="margin-right: 0; margin-left: auto;"></div>
					<p class="text-justify grey--text text--darken-1" style="line-height: 2; font-size: 1rem;">
						{{ content.desc }}
					</p>
					<v-row class="mt-4">
						<v-col v-for="(stat, i) in content.stats" :key="i" cols="4" class="text-center">
							<div class="font-weight-bold" style="font-size: 1.8rem; color: #C9A227;">{{ stat.value }}</div>
							<div class="grey--text" style="font-size: 0.8rem;">{{ stat.label }}</div>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" md="6" order="1" order-md="2" class="text-center">
					<div class="sg-about-visual">
						<v-icon size="120" color="#C9A227" class="sg-about-icon">mdi-store</v-icon>
						<div class="sg-about-ring sg-about-ring--1"></div>
						<div class="sg-about-ring sg-about-ring--2"></div>
					</div>
				</v-col>
			</v-row>
		</v-container>

		<div v-if="editable" style="position: absolute; top: 16px; left: 16px;">
			<v-btn small outlined color="primary" @click="edit()">ویرایش</v-btn>
		</div>

		<v-dialog v-model="settingsDialog" persistent max-width="550px">
			<v-card>
				<v-card-title>ویرایش معرفی</v-card-title>
				<v-card-text>
					<v-text-field v-model="settings.title" label="عنوان" outlined dense />
					<v-textarea v-model="settings.desc" label="متن" outlined dense rows="5" />
					<v-card v-for="(stat, idx) in settings.stats" :key="idx" outlined class="mb-2 pa-2">
						<v-row dense>
							<v-col cols="6"><v-text-field v-model="stat.value" label="مقدار" dense outlined /></v-col>
							<v-col cols="6"><v-text-field v-model="stat.label" label="برچسب" dense outlined /></v-col>
						</v-row>
					</v-card>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="settingsDialog = false">بستن</v-btn>
					<v-btn color="primary" :loading="submitEditLoading" @click="submitEdit">ذخیره</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
	import { cloneDeep } from 'lodash'
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'AboutSection',
		props: {
			data: { type: Object },
			contentKey: { type: String },
			editable: { type: Boolean },
		},
		data: () => ({
			localData: null,
			settings: {},
			settingsDialog: false,
			submitEditLoading: false,
		}),
		computed: {
			...get('siteConfig', ['customerCode', 'fullTitle']),
			...get('appSettings', ['landingSettings']),
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle || 'طلای سیف زاده'
			},
			content() {
				return this.localData?.content || this.defaultContent()
			},
			ccode() {
				return this.customerCode || this.$route.params.customerCode || 0
			},
		},
		mounted() {
			if (this.data) {
				this.localData = {
					id: this.data.id,
					key: this.data.key,
					isJson: this.data.isJson,
					content: JSON.parse(this.data.content),
				}
			} else {
				this.localData = {
					id: emptyId,
					key: this.contentKey,
					isJson: true,
					content: this.defaultContent(),
				}
			}
		},
		methods: {
			defaultContent() {
				return {
					title: `معرفی ${this.businessTitle}`,
					desc: `${this.businessTitle} با بیش از دو دهه تجربه در صنعت طلا و جواهر، یکی از معتبرترین فروشگاه‌های آنلاین طلا در کشور است. ما با ارائه طلای ۱۸ عیار با ضمانت اصالت، فاکتور رسمی، امکان خرید قسطی و ساخت سفارشی، تجربه‌ای امن و لذت‌بخش از خرید طلا آنلاین را برای شما فراهم کرده‌ایم. تیم متخصص ما آماده مشاوره و راهنمایی شما در انتخاب بهترین زیورآلات است.`,
					stats: [
						{ value: '+۲۰', label: 'سال تجربه' },
						{ value: '+۵۰K', label: 'مشتری راضی' },
						{ value: '۱۰۰٪', label: 'ضمانت اصالت' },
					],
				}
			},
			edit() {
				this.settings = cloneDeep(this.content)
				this.settingsDialog = true
			},
			submitEdit() {
				this.submitEditLoading = true
				const data = cloneDeep(this.localData)
				data.content = JSON.stringify(this.settings)
				api.post('admin/SiteContent/CreateUpdate', data)
					.then(() => {
						this.localData.content = cloneDeep(this.settings)
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.settingsDialog = false
					})
					.catch(err => toast.error(err.message))
					.finally(() => { this.submitEditLoading = false })
			},
		},
	}
</script>

<style lang="scss" scoped>
	.sg-about-visual {
		position: relative;
		width: 280px;
		height: 280px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.sg-about-icon {
		position: relative;
		z-index: 2;
		animation: sgFloat 4s ease-in-out infinite;
	}

	.sg-about-ring {
		position: absolute;
		border-radius: 50%;
		border: 2px solid rgba(201, 162, 39, 0.2);

		&--1 {
			width: 200px;
			height: 200px;
			animation: sgRingPulse 3s ease-in-out infinite;
		}

		&--2 {
			width: 260px;
			height: 260px;
			animation: sgRingPulse 3s ease-in-out infinite 0.5s;
		}
	}

	@keyframes sgFloat {
		0%, 100% { transform: translateY(0); }
		50% { transform: translateY(-10px); }
	}

	@keyframes sgRingPulse {
		0%, 100% { transform: scale(1); opacity: 0.5; }
		50% { transform: scale(1.05); opacity: 1; }
	}
</style>
